import React from 'react';
import {Avatar, Space, Tag} from 'antd';
import {UserDTO, UserType} from 'hemwb-api';
import {fullName} from '../../../store/user/utils';

interface UserCardAntdProps {
  user: UserDTO;
  rightContent?: React.ReactNode;
  detailsContent?: React.ReactNode;
  showStatusTags?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const UserCardAntd: React.FC<UserCardAntdProps> = ({
  user,
  rightContent,
  detailsContent,
  showStatusTags = false,
  className,
  style,
}) => {
  const isExternal = user.userType === UserType.EXTERNALUSER;
  const isInactive = user.active === false;

  const statusTags = showStatusTags && (isExternal || isInactive) && (
    <Space size={6} style={{marginTop: '4px'}}>
      {isInactive && <Tag color="error">Inactive</Tag>}
      {isExternal && <Tag color="success">EXTERNAL</Tag>}
    </Space>
  );

  return (
    <div
      className={className}
      style={{
        background: '#fff',
        border: '1px solid #d9d9d9',
        borderRadius: '4px',
        padding: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: rightContent ? 'space-between' : 'flex-start',
        gap: '12px',
        ...style,
      }}
    >
      <div style={{display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0, flex: 1}}>
        <Avatar style={{backgroundColor: '#0f62fe', flexShrink: 0}} size={40}>
          {user.firstName?.[0]}
          {user.lastName?.[0]}
          {!user.firstName && !user.lastName && user.id?.[0]}
        </Avatar>
        <div style={{minWidth: 0}}>
          <div style={{fontWeight: 500, fontSize: '14px'}}>{fullName(user)}</div>
          <div style={{fontSize: '12px', color: '#666'}}>{user.email}</div>
          {statusTags}
          {detailsContent}
        </div>
      </div>
      {rightContent}
    </div>
  );
};

export default UserCardAntd;
